import { render, staticRenderFns } from "./FormTextArea.vue?vue&type=template&id=284c0b92&scoped=true"
import script from "./FormTextArea.vue?vue&type=script&lang=js"
export * from "./FormTextArea.vue?vue&type=script&lang=js"
import style0 from "./FormTextArea.vue?vue&type=style&index=0&id=284c0b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284c0b92",
  null
  
)

export default component.exports